import React from 'react';
import {
  CALLOUT_ROUTE,
  DOC_SECTION_ROUTES,
  DOCUMENTATION_SECTIONS,
  GETTING_HELP_CALLOUT,
  GETTING_HELP_STEPS,
  HELP_STEP_ROUTES,
  HOME_INTRO_TEXT,
  KEY_FEATURES,
  QUICK_START_ITEMS,
  QUICK_START_ROUTES,
  SUPPORT_RESOURCES,
  SUPPORT_RESOURCES_ROUTES,
} from '../../constants';
import {
  BulletItem,
  BulletList,
  CalloutBox,
  ContentGrid,
  IntroText,
  DocsContent,
  NavLinkText,
  NumberItem,
  NumberList,
  TableOfContentsWrapper,
  SectionIconWrapper,
  SectionRow,
  SectionRowDescription,
  SectionRowHeading,
  SectionSubtitle,
  SectionTitle,
  TabSectionsContainer,
} from '../../styles';
import { OptionalNavLabel } from '../common/OptionalNavLabel';

export function HomeTabContent() {
  return (
    <ContentGrid>
      <DocsContent>
        <IntroText>{HOME_INTRO_TEXT}</IntroText>
        <TabSectionsContainer>
          <section>
            <SectionTitle variant="h5">Quick Start</SectionTitle>
            <SectionSubtitle>
              New to the DX Gateway? Start here:
            </SectionSubtitle>
            <BulletList>
              {QUICK_START_ITEMS.map(item => (
                <BulletItem key={item.title}>
                  <OptionalNavLabel
                    label={item.title}
                    route={QUICK_START_ROUTES[item.title]}
                  />{' '}
                  - {item.description}
                </BulletItem>
              ))}
            </BulletList>
          </section>

          <section>
            <SectionTitle variant="h5">Documentation Sections</SectionTitle>
            {DOCUMENTATION_SECTIONS.map(item => (
              <SectionRow key={item.title}>
                <SectionRowHeading>
                  <SectionIconWrapper>{item.icon}</SectionIconWrapper>
                  <OptionalNavLabel
                    label={item.title}
                    route={DOC_SECTION_ROUTES[item.title]}
                  />
                </SectionRowHeading>
                <SectionRowDescription>
                  {item.description}
                </SectionRowDescription>
              </SectionRow>
            ))}
          </section>

          <section>
            <SectionTitle variant="h5">Key Features</SectionTitle>
            <BulletList>
              {KEY_FEATURES.map(item => (
                <BulletItem key={item.title}>
                  <strong>{item.title}</strong> - {item.description}
                </BulletItem>
              ))}
            </BulletList>
          </section>

          <section>
            <SectionTitle variant="h5">Support & Resources</SectionTitle>
            <BulletList>
              {SUPPORT_RESOURCES.map(item => (
                <BulletItem key={item.title}>
                  <OptionalNavLabel
                    label={item.title}
                    route={SUPPORT_RESOURCES_ROUTES[item.title]}
                  />{' '}
                  - {item.description}
                </BulletItem>
              ))}
            </BulletList>
          </section>

          <section>
            <SectionTitle variant="h5">Getting Help</SectionTitle>
            <SectionSubtitle>
              If you need assistance or have questions:
            </SectionSubtitle>
            <NumberList>
              {GETTING_HELP_STEPS.map(step => (
                <NumberItem key={step.highlightedText}>
                  {step.textPrefix}
                  <OptionalNavLabel
                    label={step.highlightedText}
                    route={HELP_STEP_ROUTES[step.highlightedText]}
                  />
                  {step.textSuffix}
                </NumberItem>
              ))}
            </NumberList>
          </section>

          <CalloutBox>
            {GETTING_HELP_CALLOUT.textPrefix}
            <NavLinkText to={CALLOUT_ROUTE}>
              {GETTING_HELP_CALLOUT.highlightedText}
            </NavLinkText>
            {GETTING_HELP_CALLOUT.textSuffix}
          </CalloutBox>
        </TabSectionsContainer>
      </DocsContent>

      <TableOfContentsWrapper aria-hidden />
    </ContentGrid>
  );
}
